import {SuggestedActionAccordionHeader} from "../../components/SuggestedActionAccordionHeader";
import * as React from "react";
import {
    Actions,
    ActionsEnum,
    CensusEquipmentStatusDetailsEnum,
    CensusEquipmentStatusesEnum,
} from "../../data/models/CensusEnums";
import {JSONCensusEquipmentsActionsConfirmation} from "../../data/models/JSONCensusEquipmentsActionsConfirmation";
import {MappedDetailCount} from "../../data/models/JSONCensusSuggestedActionsAnalysisSummary";

export const renderHeader =
    (
        statusIcon: CensusEquipmentStatusesEnum,
        headerName: string,
        equipmentCount: number,
        suggestedAction: ActionsEnum,
        translatedActionsEnum: Actions,
        level: number,
        isMixedActionSelected: boolean,
        mergeConfirmedActions: (
            action: JSONCensusEquipmentsActionsConfirmation,
            isMixedActionSelected?: boolean,
        ) => void,
        status: CensusEquipmentStatusesEnum,
        onClick: (name: string) => void,
        availableActions: ActionsEnum[],
        description: string,
        statusDetail?: CensusEquipmentStatusDetailsEnum,
        confirmedAction?: JSONCensusEquipmentsActionsConfirmation,
        detailCount?: MappedDetailCount[],
        containsEditedActions?: boolean,
    ) =>
        (isOpen: boolean) => {
            return (
                <SuggestedActionAccordionHeader
                    equipmentCount={equipmentCount}
                    headerName={headerName}
                    isOpen={isOpen}
                    statusIcon={statusIcon}
                    suggestedAction={suggestedAction}
                    isMixedActionSelected={isMixedActionSelected}
                    mergeConfirmedActions={mergeConfirmedActions}
                    status={status}
                    statusDetail={statusDetail}
                    confirmedAction={confirmedAction}
                    level={level}
                    onClick={onClick}
                    detailCount={detailCount}
                    availableActions={availableActions}
                    translatedActionsEnum={translatedActionsEnum}
                    containsEditedActions={containsEditedActions}
                    description={description}
                />
            );
        };

